import {APIError} from '../core/errors';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';

const _api_base_url = `${BASE_URL}/lmr/customer-feedback`;



interface payloadVerify {
  payload: {
    feedback: string;
    cardNumber: string;
    orderId:string;
    mobileNo:string;
  };
  accessToken: string;
}

// test user fetch.
// TODO: remove later

export const feedbackApiCall = async (parameters: payloadVerify,
) => {
  //userEnterMobileNumber=mobileNumber;
  try {
    const response = await httpClient.post(`${_api_base_url}`, parameters.payload, {
      headers: {...DEFAULT_HEADERS,
        Authorization: `Bearer ${parameters.accessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
